// src/modules/Lessons/LessonScreen.jsx
import { useState, useEffect } from 'react';
import { fetchLessons, sendScoresToServer } from '../../api/fetchLessons';
//import lessonData from './LessonZaglushka';
import VocabularyBlock from './VocabularyBlock/VocabularyBlock';
import MatchingBlock from './MatchingBlock/MatchingBlock';
import SentenceBlock from './SentenceBlock/SentenceBlock';
import TranslateBlock from './TranslateBlock/TranslateBlock';
import IntroScreen from './IntroScreen';
import StepIndicator from './StepIndicator';
import styles from './LessonScreen.module.css';
import { handleError } from '../../context/errors/errorUtils'; // централизованная обработка ошибок
import { useDelayedLoading } from '../../hooks/useDelayedLoading';
import Loading from '../../components/Loading/Loading';
import NewUserHint from '../../components/NewUserHint/NewUserHint';


const LessonScreen = ({
  lessonId,
  blockId,
  userId,
  onExit,
  onGoPremium = null,
  audioDisabled,
  allowGrammarHints = false,
}) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeBlockType, setActiveBlockType] = useState(null); // 'vocabulary' | 'matching'  
  const [error, setError] = useState(null);
  const [accumulatedScore, setAccumulatedScore] = useState(0); // Сумма очков
  const [currentBlockIndex, setCurrentBlockIndex] = useState(0); // Текущий блок
  const [showIntro, setShowIntro] = useState(true);
  const [newUserHintClosed, setNewUserHintClosed] = useState(false); 

  const showLoading = useDelayedLoading(loading, 2000);
  
	// Загрузка данных урока
	useEffect(() => {
	  if (!lessonId || !userId) return;
	  fetchLessons({ lessonId, blockId, userId, setData, setLoading, setError });
	}, [lessonId, userId]);


  // Список типов блоков для последовательного прохождения
  const blockTypes = audioDisabled
  ? ['vocabulary', 'matching', 'sentence', 'sentence_parallel']
  : ['vocabulary', 'matching', 'sentence', 'sentence_parallel', 'translate'];

  // Обработка завершения блока
	const handleBlockComplete = (score, phrases) => {
	  const total = accumulatedScore + score;
	  setAccumulatedScore(total);

	  if (currentBlockIndex < blockTypes.length - 1) {
		setCurrentBlockIndex((prev) => prev + 1);
	  } else {
		//console.log('Все блоки завершены, отправляем очки на сервер.');
		sendScoresToServer({ userId, lessonId, blockId, score: total });
				
		// Выходим из урока
		if (typeof onExit === 'function') {
		  onExit(total, phrases); // отправляем очки, фразы и выходим на главный экран
		}
	  }
	};

  const blockType = blockTypes[currentBlockIndex];
  const hintSource = `lesson_${blockType}`;	

  if (!newUserHintClosed) { return <NewUserHint source={hintSource} onClose={() => setNewUserHintClosed(true)} />; }
  if (showLoading) { return <Loading />; }
  if (error) return <div>Error: {error.message}</div>;
  if (showIntro) { return <IntroScreen onContinue={() => setShowIntro(false)} />; }

  return (
    <div className={styles.container}>
	  <StepIndicator currentStep={currentBlockIndex} />
      <h1 className={styles.title}>{data.title}</h1>
	  
      {/* Отображение текущего блока */}
      {blockTypes[currentBlockIndex] === 'vocabulary' && (
        <VocabularyBlock
          block={data.block[0]}
          onComplete={handleBlockComplete}
        />
      )}
      {blockTypes[currentBlockIndex] === 'matching' && (
        <MatchingBlock
          block={data.block[0]}
		  previousScore={accumulatedScore}
          onComplete={handleBlockComplete}
        />
      )}
      {blockTypes[currentBlockIndex] === 'sentence' && (
        <SentenceBlock
          block={data.block[0]}
          previousScore={accumulatedScore}
          onComplete={handleBlockComplete}
		  userId={userId}
          allowGrammarHints={allowGrammarHints}
        />
      )}
      {blockTypes[currentBlockIndex] === 'sentence_parallel' && (
        <SentenceBlock
          block={data.block[0]}
          mode="parallel"
          previousScore={accumulatedScore}
          onComplete={handleBlockComplete}
		  userId={userId}
          allowGrammarHints={allowGrammarHints}
        />
      )}
      {blockTypes[currentBlockIndex] === 'translate' && (
        <TranslateBlock
          userId={userId}
          lessonId = {lessonId}
          block={data.block[0]}
          previousScore={accumulatedScore}
          onComplete={handleBlockComplete}
          onGoPremium={onGoPremium}
        />
      )}
    </div>
  );
};

export default LessonScreen;
